import { Alert } from "@mui/material";
import { useAppSelector } from "../../store/hooks";
import { selectCurrentPlan } from "../../features/pricingPlans/pricingPlans.selector";
import { selectUserPlanUsage } from "../../features/user/user.selector";

export const PlanLimitAlert = () => {
  const currentPlan = useAppSelector(selectCurrentPlan);
  const { analyzerLookupsUsed = 0 } = useAppSelector(selectUserPlanUsage);
  const lookupLimit = currentPlan?.features?.productAnalyzer?.lookups;

  if (currentPlan?.name === "free") {
    return (
      <Alert severity="error">
        The Free Plan is no longer supported. To continue, please start a free
        trial.
      </Alert>
    );
  }

  if (
    lookupLimit != null &&
    lookupLimit >= 0 &&
    lookupLimit <= analyzerLookupsUsed
  ) {
    return (
      <Alert severity="error">
        You've reached the limit for your current plan. To continue, please
        upgrade your plan.
      </Alert>
    );
  }

  return null;
};

export default PlanLimitAlert;
